import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState } from "../../../../store/store.interface";
import { ShopCartUrlContext } from "../../../../common/utils/cart-util";
import { getGuestCartToken } from "../store/shop-cart.selectors";
import { mergeGuestCartMagentoApiCall } from "../api/shop-cart.api";
import { getTokenFromMagento } from "./shop-cart-commons";
import { getCustomerId, getCustomerToken } from "../../../customer/customer";
import { getPromoCode } from "../../../promo-code/promo-code.selectors";
import { updatePromoCode } from "./update-promo-code.thunk";
import { getZipCode } from "../../../estimated-tax/estimated-tax.selectors";
import { getEstimatedTax } from "../../../estimated-tax/estimated-tax.thunks";
import { ActionStatus } from "../../../../common/constants/action-status";

export const mergeGuestCart = createAsyncThunk('mergeguestcart/mergeCart', async (_shopCartUrlContext: ShopCartUrlContext, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as StoreState;
      const guestCartToken = getGuestCartToken(state);

      await getTokenFromMagento(thunkAPI);
      const customerId = getCustomerId(state);
      const customerToken = getCustomerToken(state);
      return await mergeGuestCartMagentoApiCall(customerId, guestCartToken, customerToken);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    } finally {
      const state = thunkAPI.getState() as StoreState;
  
      // If we have already found a promo code, update it after the quantity changes
      const promoCode = getPromoCode(state);
      if (promoCode) {
        thunkAPI.dispatch(updatePromoCode({ promoCode, forceUpdate: true }));
      }
  
      // If we have already found an estimated tax, update it after the quantity changes
      const zipCode = getZipCode(state);
      if (zipCode) {
        thunkAPI.dispatch(getEstimatedTax({ zipCode }));
      }
    }
  }, {
    condition: ((_arg, { getState }) => {
      const state = getState() as StoreState;
      if (state.shopCartState.mergeGuestCart.status == ActionStatus.loading || state.shopCartState.mergeGuestCart.status == ActionStatus.succeeded) {
        return false;
      }
      return true;
    })
  });